import React from 'react';

const CaretBorder = (props) => {

    return (
        <div className="caret-border"></div>
    );
}

export default CaretBorder;